import { inter } from "../fonts/inter";
import { motion } from "framer-motion";
import HeroBackground from "../components/background/HeroBackground";
import React from "react";
import AnimatedTitle from "../animations/AnimatedTitle";

const Hero = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[100vh] w-full justify-center"
      id="home"
      initial="initial"
      animate="animate"
    >
      <HeroBackground />
      <div className="absolute inset-0 bg-black/70 z-5"></div>
      <div className="mt-10 flex flex-col items-center justify-center sm:mt-0 relative z-10">
        <div
          className={`relative flex flex-col items-center justify-center ${inter.className} pointer-events-none`}
        >
          <p className="text-[20px] md:text-[30px] text-[#ff0077] mb-4">
            Hello , World !
          </p>
          <AnimatedTitle
            text={"I'm Alex Sunday"}
            className={
              " text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#ffffff] sm:text-[45px] md:mb-5 md:text-[60px] lg:text-[80px]"
            }
            wordSpace={"mr-[10px]"}
            charSpace={"mr-[0.001em]"}
            tag="h1"
          />
          <p className="text-[16px] md:text-[20px] text-[#cecece]">
            | Fullstack Developer | UI/UX Designer |{" "}
          </p>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
